/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { memo, useMemo } from 'react';
import './Navbar.scss';
import MarkazIcon from 'assets/icons/logo.png';
import sortArrow from 'assets/icons/sort-arrow.svg';
import { useIntl } from 'react-intl';
import { clearClientData } from 'shared/context/actions';
import connect from 'shared/context/connect';
import { Button } from 'components';
import { decodeToken } from 'utils/helper';

interface Props {
  onClearClientData,
  clientData,
  onShowOtpPopup: ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void) | undefined,
}

const Navbar: React.FC<Props> = ({
  onClearClientData, clientData, onShowOtpPopup,
}): JSX.Element => {
  const intl = useIntl();
  const showECatalogTab = useMemo(() => {
    const { userRoles, applications } = decodeToken(clientData?.token);
    return (userRoles.includes('MARKAZ_ADMIN') || userRoles.includes('ROLE_ADMIN'))
      && (applications.includes('MARKAZ_DATA_STAGING') || applications.includes('MARKAZ_DATA_HUB_PROD'));
  }, [clientData]);

  const showUserMgtTab = useMemo(() => {
    const { userRoles } = decodeToken(clientData?.token);
    return !!userRoles.includes('ROLE_ADMIN');
  }, [clientData]);

  const handleLogout = async () => {
    await onClearClientData(clientData.token);
  };

  return (
    <nav className="navbar">
      <div className="branding-navs">
        <img src={MarkazIcon} alt="markaz icon" width="140px" />
        <ol className="branding-navs__tabs">
          <li className="current"><span>Online Application</span></li>
          {showECatalogTab ? (
            <>
              <li>
                <a href={process.env.REACT_APP_ECATALOGUE_MO_URL}>e-Catalogue</a>
              </li>
            </>
          ) : null}
          {showUserMgtTab ? (
            <li>
              <a href={`${process.env.REACT_APP_ECATALOGUE_MO_URL}/user-management?pageIndex=1`}>User Management</a>
            </li>
          ) : null}
        </ol>
      </div>
      <ul>
        <li>
          <Button value={intl.formatMessage({ id: 'navbar.otp' })} onButtonClick={onShowOtpPopup} isSecondary />
        </li>
        <li>
          <small>
            {clientData.email}
            <img src={sortArrow} width={12} height={12} alt="dropdown" />
          </small>
          <ul className="dropdownList">
            <li><span onClick={handleLogout}>{intl.formatMessage({ id: 'navbar.logout' })}</span></li>
          </ul>
        </li>
      </ul>
    </nav>
  );
};

const mapStateToProps = ({ rootState }) => ({
  clientData: rootState.clientData,
});

const mapDispatchToProps = ({
  onClearClientData: clearClientData,
});

export default connect(mapStateToProps, mapDispatchToProps)(memo(Navbar));
